<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getAttachmentFileName } from 'shared/helpers/FileHelper';

import { useMessageContext } from '../provider.js';
import BaseAttachmentBubble from './BaseAttachment.vue';
import FileIcon from 'next/icon/FileIcon.vue';

const { attachments } = useMessageContext();

const { t } = useI18n();

const url = computed(() => {
  return attachments.value[0].dataUrl;
});

const fileName = computed(
  () =>
    getAttachmentFileName(attachments.value[0]) ||
    t('CONVERSATION.UNKNOWN_FILE_TYPE')
);

const fileType = computed(() => {
  return fileName.value.split('.').pop();
});
</script>

<template>
  <BaseAttachmentBubble
    icon="i-teenyicons-user-circle-solid"
    icon-bg-color="bg-n-alpha-3 dark:bg-n-alpha-white"
    sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.FILE"
    :content="fileName"
    :action="{
      href: url,
      label: $t('CONVERSATION.DOWNLOAD'),
    }"
  >
    <template #icon>
      <FileIcon :file-type="fileType" class="size-4" />
    </template>
  </BaseAttachmentBubble>
</template>
